import { createAsyncThunk } from '@reduxjs/toolkit';

import { createAddressStringFromObject } from 'utils/address';
import { EMPTY_VALUE_SYMBOL } from 'utils/constants';
import { applicationApi } from 'api/ApplicationApi';

import { clearApplication } from '../actions/application';
import { setBorrower } from '../actions/borrower';
import { setCoBorrower } from '../actions/coBorrower';
import { setCoOwner } from '../actions/coOwnerInfo';
import { setDashboardStep } from '../actions/stages';
import { ApplicationStatus } from '../enums/ApplicationStatus';
import { DashboardStep } from '../enums/DashboardStep';
import { STATUSES_AS_PROCESSING } from '../pages/Dashboard/dashboard.constants';
import { updateApplicationInStore } from '../utils/updateApplicationInStore';
import { updateDocuments } from '../utils/updateDocuments';
import { updateRequiredInformation } from '../utils/updateRequiredInformation';

export const getApplicationInfoForDashboardThunk = createAsyncThunk(
  'application/GetApplicationInfo',
  async (borrowerId: string, { dispatch }) => {
    try {
      const { borrowerApplication } = await applicationApi.getActiveApplication();

      if (!borrowerApplication) {
        dispatch(clearApplication());
        dispatch(setDashboardStep(DashboardStep.NoActiveApplication));

        return [];
      }

      const { variables, status } = borrowerApplication;

      updateApplicationInStore(borrowerApplication, dispatch);
      dispatch(
        setBorrower({
          firstName: variables.borrower_first_name as string,
          lastName: variables.borrower_last_name as string,
        }),
      );
      dispatch(
        setCoBorrower({
          firstName: variables.coborrower_first_name as string,
          lastName: variables.coborrower_last_name as string,
          email: variables.coborrower_email as string,
        }),
      );

      if (STATUSES_AS_PROCESSING.includes(status.name as ApplicationStatus)) {
        updateRequiredInformation(borrowerApplication, dispatch);
        updateDocuments(borrowerApplication, dispatch);

        if (variables.is_there_a_non_borrowing_coowner) {
          dispatch(
            setCoOwner({
              firstName: variables.non_borrowing_coowner_first_name || EMPTY_VALUE_SYMBOL,
              lastName: variables.non_borrowing_coowner_last_name || EMPTY_VALUE_SYMBOL,
              middleName: variables.non_borrowing_coowner_middle_name || EMPTY_VALUE_SYMBOL,
              address: createAddressStringFromObject(variables.borrower_work_order_address_verified),
              city: variables.borrower_work_order_address_verified?.city || EMPTY_VALUE_SYMBOL,
              state: variables.borrower_work_order_address_verified?.state_or_province || EMPTY_VALUE_SYMBOL,
              zip: variables.borrower_work_order_address_verified?.zip_or_postal_code || EMPTY_VALUE_SYMBOL,
              last4SSN: variables.non_borrowing_coowner_ssn || '',
              phoneNumber: variables.non_borrowing_coowner_mobile_phone || '',
              email: variables.non_borrowing_coowner_email_address || '',
              dateOfBirth: variables.non_borrowing_coowner_dob || '',
            }),
          );
        }
      }

      return borrowerApplication;
    } catch (error: any) {
      dispatch(setDashboardStep(DashboardStep.NotFoundContact));

      return [];
    }
  },
);
